/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import R from 'ramda'
import moment from 'moment'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Divider, ListItem as MaterialListItem, FontIcon, Chip, CircularProgress } from 'material-ui'
import { red500, green500, grey500 } from 'material-ui/styles/colors'

import { ListItem } from 'generic/list'

import * as proposalActions from 'actions/Proposal'
import * as constants from 'constants/Proposal'
import * as prestationConstants from 'constants/Prestation'
import * as loginConstants from 'constants/Login'

class PrestationProposalPanel extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      prestationProposals: [],
      open: false
    }
  }

  componentDidMount() {
    this.handleLoadPrestationProposals()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.prestation !== this.props.prestation) {
      this.handleLoadPrestationProposals()
    }
  }

  handleLoadPrestationProposals() {
    this.setState({
      prestationProposals: []
    })

    const params = {
      prestation: this.props.prestation.uid,
      sort: 'interpreter__identities__first_name, interpreter__identities__last_name, start_time'
    }

    let prestationProposals = []
    let open = false
    proposalActions.getPrestationProposals(params)
      .then((result) => {
        result.data.objects.objects.map((prestationProposal) => {
          const step = R.path(['workflow_objects', 0, 'step_name'], prestationProposal)
          if (step === constants.NEW_PRESTATION_PROPOSAL_STATUS) {
            open = true
          }

          let key
          let obj = {
            proposalType: prestationProposal.proposal_type,
            objs: [],
            steps: [],
          }

          const applicant_proposal = prestationProposals.find(obj => obj.uid === this.props.prestation.applicant.uid)
          const interpreter_proposal = prestationProposals.find(obj => obj.uid === prestationProposal.interpreter.uid)
          if (obj.proposalType === constants.APPLICANT_PROPOSAL_TYPE &&
              applicant_proposal) {
            key = applicant_proposal.uid

          } else if (obj.proposalType === constants.APPLICANT_PROPOSAL_TYPE) {
            key = this.props.prestation.applicant.uid

            prestationProposals.push({
              ...obj,
              uid: key,
              primaryText: this.props.applicantName,
            })
          } else if (obj.proposalType === constants.INTERPRETER_PROPOSAL_TYPE &&
                     interpreter_proposal) {
            key = interpreter_proposal.uid

          } else if (obj.proposalType === constants.INTERPRETER_PROPOSAL_TYPE) {
            key = prestationProposal.interpreter.uid

            prestationProposals.push({
              ...obj,
              uid: key,
              primaryText: R.path(['interpreter', 'identities', 0, 'first_name'], prestationProposal) + ' ' + R.path(['interpreter', 'identities', 0, 'last_name'], prestationProposal),
            })
          }

          prestationProposals = prestationProposals.map(obj => {
            if (obj.uid === key) {
              obj.objs.push(prestationProposal)
              obj.steps.push(step)
            }

            return obj
          })
        })
      })
      .finally(() => {
        this.setState({
          prestationProposals: prestationProposals,
          open: open
        })
      })
  }

  handlePrestationProposalChange(obj, name, value) {
    const prestationProposals = this.state.prestationProposals.map(prestationProposal => {
      const objs = prestationProposal.objs.map(element => {
        if (element.uid === obj.uid) {
          return {
            ...element,
            [name]: value
          }
        }
        return element
      })

      return {
        ...prestationProposal,
        objs: objs
      }
    })

    this.setState({
      prestationProposals: prestationProposals
    })
  }

  handleExecuteOperation(obj, stepName) {
    this.handlePrestationProposalChange(obj, 'loading', true)

    const data = {
      name: constants.WORKFLOW_NAME,
      step_name: stepName
    }

    proposalActions.executePrestationProposalOperation(obj.uid, data)
      .then(() => {
        this.handleLoadPrestationProposals()
        if (this.props.handleUpdatedPrestation) {
          this.props.handleUpdatedPrestation(this.props.prestation)
        }
        this.props.actions.selectPrestation(this.props.prestation)
      })
      .catch((errors) => {
        let message = errors.statusText
        if (errors.status === 400) {
          message = R.path(['data', 'field_errors', 0, 'errors', 0, 'user_message'], errors) || message
        }
        this.handlePrestationProposalChange(obj, 'proposalError', message)
      })
      .finally(() => {
        this.handlePrestationProposalChange(obj, 'loading', false)
      })
  }

  render () {
    const initialStartTime = moment(this.props.prestation.initial_start_time)
    const initialEndTime = moment(this.props.prestation.initial_end_time)
    const initialSchedule = `Le ${initialStartTime.format('DD.MM.YYYY')}, de ${initialStartTime.format('HH:mm')} à ${initialEndTime.format('HH:mm')}`

    const receivedProposalType = {
      [loginConstants.APPLICANT_ROLE]: constants.INTERPRETER_PROPOSAL_TYPE,
      [loginConstants.INTERPRETER_ROLE]: constants.APPLICANT_PROPOSAL_TYPE,
    }[this.props.user.role]

    return (
      <React.Fragment>
        {
          this.state.prestationProposals.length
            ? <React.Fragment>
              <Divider/>

              <MaterialListItem
                primaryText={this.props.intl.formatMessage(prestationConstants.messages.DETAIL_PROPOSALS_LABEL)}
                initiallyOpen={this.state.open}
                primaryTogglesNestedList={true}
                nestedItems={[
                  <ListItem
                    key={0}
                    disabled={true}
                    primaryText={initialSchedule}
                    secondaryText={this.props.intl.formatMessage({id: 'prestation.INITIAL_SCHEDULE_LABEL'})}
                    style={{
                      textAlign: 'center',
                    }}
                  />,
                  this.state.prestationProposals.map((obj, index) => {
                    const isOngoing = obj.steps.indexOf(constants.NEW_PRESTATION_PROPOSAL_STATUS) !== -1

                    return (
                      <ListItem
                        key={index}
                        initiallyOpen={isOngoing}
                        primaryText={obj.primaryText}
                        secondaryText={
                          <div>
                            {
                              obj.proposalType === constants.INTERPRETER_PROPOSAL_TYPE
                                ? this.props.intl.formatMessage(prestationConstants.messages.DETAIL_INTERPRETER_LABEL)
                                : this.props.intl.formatMessage(prestationConstants.messages.DETAIL_APPLICANT_LABEL)
                            }
                            <Chip
                              backgroundColor={
                                isOngoing
                                  ? green500
                                  : grey500
                              }
                              labelColor='white'
                              labelStyle={{lineHeight: 0}}
                              style={{
                                display: 'inline-block',
                                float: 'right',
                                right: 25,
                                textAlign: 'center',
                              }}
                            >
                              {
                                isOngoing
                                  ? this.props.intl.formatMessage(prestationConstants.messages.DETAIL_PROPOSALS_ONGOING)
                                  : this.props.intl.formatMessage(prestationConstants.messages.DETAIL_PROPOSALS_CLOSED)
                              }
                            </Chip>
                          </div>
                        }
                        primaryTogglesNestedList={true}
                        nestedItems={
                          obj.objs.map((prestationProposal, index) => {
                            const operations = R.path(['workflow_objects', 0, 'operations'], prestationProposal)
                            const stepName = R.path(['workflow_objects', 0, 'step_name'], prestationProposal)
                            let proposalText
                            let createdText

                            const createdMoment = moment(prestationProposal.created_time, 'YYYY-MM-DD HH:mm:ss')
                            const createdDate = createdMoment.format('DD.MM.YYYY')
                            const createdTime = createdMoment.format('HH:mm')

                            const createdIntro = prestationProposal.proposal_type === receivedProposalType
                              ? this.props.intl.formatMessage(prestationConstants.messages.DETAIL_PROPOSALS_RECEIVED)
                              : this.props.intl.formatMessage(prestationConstants.messages.DETAIL_PROPOSALS_SENT)

                            createdText = `${createdIntro} ${createdDate} à ${createdTime}`

                            if (prestationProposal.prestation_type) {
                              const prestationType = this.props.prestationTypes.find(o => o.uid === prestationProposal.prestation_type)

                              proposalText = prestationType.value
                            } else {

                              const startMoment = moment(prestationProposal.start_time, 'YYYY-MM-DD HH:mm:ss')
                              const startDate = startMoment.format('DD.MM.YYYY')
                              const startTime = startMoment.format('HH:mm')
                              const endTime = moment(prestationProposal.end_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

                              proposalText = `${moment(prestationProposal.start_time).format('dddd').capitalize()} ${startDate}, ${startTime} à ${endTime}`
                            }

                            return (
                              <ListItem
                                key={index}
                                primaryText={
                                  <React.Fragment>
                                    <div
                                      className="row"
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <div
                                        style={{
                                          minWidth: '60%',
                                          lineHeight: 2,
                                        }}
                                      >
                                        {proposalText}
                                      </div>

                                      {
                                        prestationProposal.loading
                                        ? <CircularProgress
                                          className='inline center'
                                          size={20}
                                        />
                                        : <div
                                          className='inline center'
                                          style={{
                                            minWidth: '20%'
                                          }}
                                        >
                                          {
                                            operations.find(operation => operation.name === constants.ACCEPT_PROPOSAL_ACTION) &&
                                            (prestationProposal.proposal_type === receivedProposalType)
                                              ? <FontIcon
                                                style={{cursor: 'pointer'}}
                                                className='material-icons inline middle'
                                                color={green500}
                                                onClick={() => this.handleExecuteOperation(
                                                    prestationProposal,
                                                    constants.ACCEPT_PROPOSAL_ACTION
                                                  )
                                                }
                                              >
                                                done
                                              </FontIcon>
                                              : undefined
                                          }

                                          {
                                            operations.find(operation => operation.name === constants.REFUSE_PROPOSAL_ACTION) &&
                                            (prestationProposal.proposal_type === receivedProposalType)
                                              ? <FontIcon
                                                style={{cursor: 'pointer', marginLeft: 10}}
                                                className='material-icons inline middle'
                                                color={red500}
                                                onClick={() => this.handleExecuteOperation(
                                                    prestationProposal,
                                                    constants.REFUSE_PROPOSAL_ACTION
                                                  )
                                                }
                                              >
                                                close
                                              </FontIcon>
                                              : undefined
                                          }
                                        </div>
                                      }

                                      <Chip
                                        backgroundColor={constants.PRESTATION_PROPOSAL_STATUS_COLOR[stepName]}
                                        labelColor='white'
                                        style={{
                                          display: 'inline-block',
                                          float: 'right',
                                          minWidth: 85,
                                          textAlign: 'center',
                                        }}
                                      >
                                        {R.path(['workflow_objects', 0, 'display_step_name'], prestationProposal)}
                                      </Chip>
                                    </div>
                                  </React.Fragment>
                                }
                                secondaryText={
                                  <div style={{marginTop: 0, overflow: 'visible'}}>
                                    {prestationProposal.proposalError
                                      ? <span style={{color: red500, lineHeight: 0}}>
                                        {prestationProposal.proposalError}
                                      </span>
                                      : createdText
                                    }                                    
                                  </div>
                                }
                              />
                            )
                          })
                        }
                      />
                    )
                  }) 
                ]}
              />
            </React.Fragment>
            : undefined
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
  prestationTypes: state.ApplicantPrestation.prestationTypes,
})

export default connect(
  mapStateToProps, 
  undefined
)(injectIntl(PrestationProposalPanel))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/PrestationProposalPanel.js